import {useQuery} from '@tanstack/react-query'

import {Api} from '@settings/api'

export const QueryKey = 'signal-names'

const parseToAutocompleteOptions = (data: string[]) => data.map((type) => ({label: type, id: type}))

export const useGetSignalNames = (
  plantCode: string,
  searchTerm: string | null,
  signalSource?: string | null
) => {
  return useQuery({
    queryKey: [QueryKey, signalSource, plantCode, searchTerm],
    queryFn: async () => {
      const path = `upm/signal/plant/${plantCode}/local-names`
      return (await Api.axiosInstance.get<string[]>(path, {params: {signalSource, searchTerm}}))
        .data
    },
    staleTime: Infinity,
    select: parseToAutocompleteOptions,
    enabled:
      signalSource !== undefined &&
      searchTerm !== null &&
      signalSource !== null &&
      searchTerm.length > 2,
    retry: 0
  })
}
